import React from 'react'
import './Tip.css'

export default ({ children }) => (
  <section className="tip">
    {children}
  </section>
)
